import Axios, {
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
  AxiosError,
} from 'axios';

import { getAuthToken } from './token';
import { ApiErrorResponse } from './types';

export const api = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL,
  headers: { 'Access-Control-Allow-Origin': '*' },
});

const authRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  if (typeof window !== 'undefined') {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
};

api.interceptors.request.use(authRequestInterceptor);

export const apiClient = <TData, TError = ApiErrorResponse>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const source = Axios.CancelToken.source();
  const promise = api({
    ...config,
    ...options,
    cancelToken: source.token,
  })
    .then((response) => response.data)
    .catch((error: AxiosError<TError>) => {
      throw error.response?.data ?? error;
    });

  // @ts-expect-error - This is a custom property
  promise.cancel = () => source.cancel('Query was cancelled.');

  return promise;
};
